// Modal.js
import React from 'react';
import './Modal.css';
import animation from '../../../images/jm-animation.gif';

const RenderLoading = ({ showModal }) => {
  return (
    <>
      <div className='container-div'>
        <div className="textcentervertex" role="status" aria-live="polite" aria-busy="true">

          <img src={animation} alt="" aria-hidden="true" />
          <div className="model_popup">Please Wait...</div>
        </div>
      </div>
    </>

  );
};

export default RenderLoading;
